import {Pipe, PipeTransform} from '@angular/core';
import {getMonthName} from "../global";

@Pipe({
  name: 'datePipe',
  standalone: true
})
export class NewDatePipe implements PipeTransform {

  transform(timestamp: number): unknown {
    if (!timestamp) return;
    let date = new Date(timestamp);
    return getMonthName(date.getMonth() + 1, true, true) + ' ' + date.getFullYear() + 'г.';
  }


}
